import * as React from 'react';

import {Error404Page} from '../components';
type Props = {
};

export const Error404PageContainer: React.FC<Props> = props => {
    return <Error404Page />;
};

